import { render, staticRenderFns } from "./FaqCategories.vue?vue&type=template&id=89f8a06a&"
import script from "./FaqCategories.vue?vue&type=script&lang=js&"
export * from "./FaqCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports